import { types } from '../../../types/types';

export const reducerPesquisaProdPreco = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PRODPRECOSPESQUISA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const reducerProdPrecoSelecionado = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.SUBITEMPRECOSELECIONADO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const reducerProdPrecoNovoAtualiza = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PRODNOVOATUALIZA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}